import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useStyles from "../styles";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import { useFormContext } from "react-hook-form";
import ToggleWithText from "Components/formControls/HookFields/ToggleWithText";
const Reports = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { features, disabledView } = watch();

  return (
    <Box className={classes.root}>
      <Accordion data-testid="accord" className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordionSummary}
        >
          <Typography className={classes.heading}>{t("Reports")}</Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Box display="flex">
            <Box className={classes.targetWrapper} p={3} mr={1.5}>
              <Typography className={classes.heading}>
                Success stories
              </Typography>
              <Box
                mt={2}
                alignItems="center"
                className={disabledView ? classes.disabledView : ""}
              >
                <Typography className={classes.switchLabel}>
                  Allow people to create success stories
                </Typography>
                <ToggleWithText
                  register={register("features.report.createSuccessStory")}
                  name={"features.report.createSuccessStory"}
                  checked={get(features, "report.createSuccessStory", false)}
                  // disabled={disabledView}
                  defaultChecked={features?.report?.createSuccessStory || false}
                />
              </Box>
            </Box>

            <Box className={classes.targetWrapper} p={3} ml={1.5}>
              <Typography className={classes.heading}>
                Performance reviews
              </Typography>
              <Box
                mt={2}
                alignItems="center"
                className={disabledView ? classes.disabledView : ""}
              >
                <Typography className={classes.switchLabel} display="block">
                  Allow people to create performance reviews
                </Typography>
                <ToggleWithText
                  register={register("features.report.createPerformanceReview")}
                  name={"features.report.createPerformanceReview"}
                  checked={get(
                    features,
                    "report.createPerformanceReview",
                    false
                  )}
                  defaultChecked={
                    features?.report?.createPerformanceReview || false
                  }

                  // disabled={disabledView}
                />
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
export default Reports;
